import { DatePipe } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ActiveElement, ChartOptions } from 'chart.js';
import { ChartEvent } from 'chart.js/dist/core/core.plugins';


export interface IChartData {
  label: string,
  data: string[],
  color?: string
}

export interface IChart {
  labels: string[];
  datasets: IChartData[];
}

export class ChartData implements IChartData {
  label: string;
  data: string[];
  color: string;
  fill: boolean = true;
  tension: number = 0;
  pointBorderColor?: string;
  borderColor?: string;
  pointBackgroundColor: string = '#fff';
  pointBorderWidth: string = '2';

  constructor(data: IChartData) {
    this.label = data.label;
    this.data = data.data;
    this.color = data.color || DEFAULT_COLOR;
    this.borderColor = data.color || DEFAULT_COLOR;
  }

  backgroundColor(context: any) {
    if (!context.chart.chartArea) {
      return;
    }
    const { ctx, chartArea: { top, bottom } } = context.chart;
    const gradinet = ctx.createLinearGradient(0, top, 0, bottom)
    gradinet.addColorStop(0, context.dataset.color);
    gradinet.addColorStop(0.7, 'rgba(255, 255, 255, 0)');
    return gradinet;
  }

  
}

interface  ITooltipChart {
  right: string;
  left: string;
  display: string;
  text: {title: string, subtitle: string};
  color: string;
}

class TooltipChart implements ITooltipChart {
  right: string;
  left: string;
  display: string;
  text: {title: string, subtitle: string};
  color: string;

  constructor(tooltip?: ITooltipChart) {
    this.right = tooltip?.right || '0px';
    this.left = tooltip?.left || '0px';
    this.display = tooltip?.display || 'none';
    this.text = tooltip?.text || { title: '', subtitle: '' };
    this.color = tooltip?.color || '';
  }
}

const DEFAULT_COLOR = '#FF9847';

@Component({
  selector: 'split-chart-line',
  templateUrl: './split-chart-line.component.html',
  styleUrls: ['./split-chart-line.component.scss']
})
export class SplitChartLineComponent implements OnChanges {



    @Input() chart!: IChart;
    @Input() showLegend: boolean = false
    @Input() highlightLastLabel: boolean = true

    protected options!: ChartOptions;
    protected tooltip: ITooltipChart = new TooltipChart();

    protected data: IChart = {
      labels: [],
      datasets: []
    };


    constructor(private datePipe: DatePipe) {}


    ngOnChanges(changes: SimpleChanges): void {
      if(changes['chart'] && changes['chart'].currentValue) {
        this.data = this.chart;
        this.data.datasets = this.chart.datasets.map((data: IChartData) => new ChartData(data));
        console.log(this.data.datasets);
      }


      this.options = {
        onHover: (event: ChartEvent, elements: ActiveElement[]) => {
          if (elements.length > 0) {
            this.tooltip = {
              left: (event.x as number + 20) + 'px',
              right: event.y + 'px',
              display: 'block',
              text: {title: this.chart.labels[elements[0].index], subtitle: this.chart.datasets[elements[0].datasetIndex].data![elements[0].index]},
              color: this.chart.datasets[elements[0].datasetIndex].color || DEFAULT_COLOR
            }
          } else {
            this.tooltip.display = 'none';
          }
        },
        maintainAspectRatio: false,
        aspectRatio: 0.6,
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            enabled: false,
          }
        },
        scales: {
          x: {
            ticks: {
              font: {
                family: 'Poppins',
                size: 13,
                weight: (c) => {
                  if (c['tick']['value'] === (this.chart.labels.length - 1) && this.highlightLastLabel) {
                    return 700
                  } else {
                    return 400
                  }
                }
              },
              padding: 10,
              color: (c) => {
                if (c['tick']['value'] === (this.chart.labels.length - 1) && this.highlightLastLabel) {
                  return this.chart.datasets[0].color
                } else {
                  return '#999999'
                }
              },
              callback: (value, index, values) => {
                let date = new Date(this.chart.labels[index]);
                date.setMinutes(date.getTimezoneOffset());
                let dateFormat = this.datePipe.transform(date, 'dd/MM');
                return dateFormat;
              }
            },
            grid: {
              display: false,
            }
          },
          y: {
            beginAtZero: true,
            grid: {
              color: "#F5F5F5"
            },
            ticks: {
              font: {
                family: 'Poppins',
                size: 13,
                weight: 400
              },
              padding: 20,
              color: '#999999',
              stepSize: 200,
              
              callback: function (value: any) {
                return 'R$ ' + value;
              }
  
            }
          },
  
        },
        elements: {
          point:{
            hitRadius: 5
          }
        }
      }
    }


}
